import React from "react";
import dayjs from "dayjs";
import {t} from "i18next";
import {DG_Format_Money, formatCurrency} from "../../../../../../format/Money";

export const borderColorCell = "#FF3838"
export const to2Floor = (value) => {
    //todo truong hop cong qua nho 0.00xxx => khong lay
    if (value) {
        return (Math.floor(value * 100) / 100)?.toString()?.replace('.', ',');
    }
    return 0;
}

export const convertHoursToHoursAndMinutes = (totalHours) => {

    const absString = totalHours < 0 ? -1 : 1
    const hours = Math.floor(Math.abs(totalHours)) * absString;
    const minutes = Math.round((Math.abs(totalHours) - Math.abs(hours)) * 60);

    const hoursString = hours === 0 ? "" : `${hours}h`
    const minutesString = minutes === 0 ? "" :  `${minutes}p`

    return `${hoursString}${minutesString}`;
}


export function roundToNearestTenth(number) {

    if (isNumber(number)) {
        const numberArray = number.toString()?.split(".");

        if (numberArray?.length >= 2 && (Number(numberArray[1] > 9))) {
            return (roundToDecimal(number))?.toString()?.replace('.', ',') + "..."
        } else {
            return (roundToDecimal(number))?.toString()?.replace('.', ',')
        }

    } else {
        return ""
    }
}

export function isNumber(string) {
    return !isNaN(parseFloat(string)) && isFinite(string);
}

export function roundToDecimal(number) {
    const decimalPlaces = 1;
    const multiplier = Math.pow(10, decimalPlaces);
    return (Math.floor(number * multiplier) / multiplier)?.toString()?.replace('.', ',');
}

export function getColorBackground(value,type) {

    if (value?.isEditManual === 1) {
        return colorBackground.editManual
    }
    if (value?.isHoliday === true) {
        return colorBackground.holiday
    }
    else if (value?.isAutoTimekeeping) {
        return colorBackground.manual
    }
    else if (value?.isCasual) {
        return colorBackground.casual
    }
    else if ((value?.checkInOut?.trim()?.toLowerCase() !== "xx:xx - xx:xx"
        && value?.checkInOut?.trim() !== "") ||
        (value?.workday?.toUpperCase() !== "N" && value?.workday !== "" && value?.workday?.toUpperCase() !== "X"))
        return colorBackground.workday
    else {
        return colorBackground.leaveNoReason
    }
}

export function buildWorkday(value, id, selectRowColor, type, date,isLeaveAllDay) {
    if (value?.isEditManual === 1) {
        return <div
            className="detail-workday rectangle-angle"
            color-type={colorBackground.editManual}
            style={{
                background: colorBackground.editManual,
                fontWeight: 600,
                color: "#fff",
                border: selectRowColor && selectRowColor?.cellIndex === 'workday' && selectRowColor?.id === id ? `3px solid ${selectRowColor?.value}` : null

            }}>
            {t("tnp.components.timesheetViewport.text1")}
        </div>
    }
    else if (value?.isAutoTimekeeping) {
        return <div
            className="detail-workday rectangle-angle"
            color-type={colorBackground.manual}
            style={{
                background: colorBackground.manual,
                fontWeight: 600,
                color: "#fff",
                border: selectRowColor && selectRowColor?.cellIndex === 'workday' && selectRowColor?.id === id ? `3px solid ${selectRowColor?.value}` : null

            }}>
            {t("tnp.components.timesheetViewport.text2")}</div>
    }
    else if (value?.isHoliday === true) {
        return <div
            className="detail-workday rectangle-angle"
            color-type={colorBackground.holiday}
            style={{
                background: colorBackground.holiday,
                fontWeight: 600,
                color: "#fff",
                border: selectRowColor && selectRowColor?.cellIndex === 'workday' && selectRowColor?.id === id ? `3px solid ${selectRowColor?.value}` : null

            }}>
            {t("tnp.components.timesheetViewport.text3")}</div>
    }

    else if (value?.isCasual) {
        return <div
            className="detail-workday rectangle-angle"
            color-type={colorBackground.casual}
            style={{
                background: colorBackground.casual,
                fontWeight: 600,
                color: "#fff",
                border: selectRowColor && selectRowColor?.cellIndex === 'workday' && selectRowColor?.id === id ? `3px solid ${selectRowColor?.value}` : null

            }}>  {
            isLeaveAllDay ? t("tnp.components.timesheetViewport.text4") : value?.checkInOut
        }</div>

    }

    else if ((value?.checkInOut && value.checkInOut?.trim()?.toLowerCase() !== "xx:xx - xx:xx")
        || (value?.workday?.toUpperCase() !== "N" && value?.workday !== "" && value?.workday?.toUpperCase() !== "X"))
        return <div
            className="detail-workday rectangle-angle"
            color-type={colorBackground.workday}
            style={{
                background: colorBackground.workday,
                fontWeight: 600,
                color: "#fff",
                border: selectRowColor && selectRowColor?.cellIndex === 'workday' && selectRowColor?.id === id ? `3px solid ${selectRowColor?.value}` : null
            }}> {value?.checkInOut} </div>
    else if ((type === "byDay" || type === null || type === undefined) &&
        date && (date?.isAfter(dayjs(), 'date') ||
            date?.isSame(dayjs(), 'date')) && value?.workday !== "N" && value?.workday !== "X") {
        return <div
            className="detail-workday rectangle-angle"
            color-type={colorBackground.leaveNoReason}
            style={{
                background: colorBackground.leaveNoReason,
                fontWeight: 600,
                color: "#344054",
                border: selectRowColor && selectRowColor?.cellIndex === 'workday' &&
                selectRowColor?.id === id ? `3px solid ${selectRowColor?.value}` : null
            }}>  {t("tnp.components.timesheetViewport.text5")}</div>
    }

    else {
        return <div
            className="detail-workday rectangle-angle"
            color-type={colorBackground.leaveNoReason}
            style={{
                background: colorBackground.leaveNoReason,
                fontWeight: 600,
                color: "#344054",
                border: selectRowColor && selectRowColor?.cellIndex === 'workday' &&
                selectRowColor?.id === id ? `3px solid ${selectRowColor?.value}` : null
            }}>
        </div>
    }

}


export const mapDateFixTimeKeeping = (values) => {

    return values?.map(item => {
        return {
            ...item,
            totalWorkDay: formatCurrency(item?.totalWorkDay || 0),
            standardPoints: formatCurrency(item?.standardPoints || 0),
            leaveP: formatCurrency(item?.leaveP || 0),
            totalWorkHour: formatCurrency(item?.totalWorkHour || 0),
            annualLeaveTotalRemain: formatCurrency(item?.annualLeave?.totalRemain || 0),
            annualLeave: formatCurrency(item?.annualLeave?.totalHours || 0),
            lateInMinute: formatCurrency(item?.lateIn?.minute || 0),
            earlyOutMinute: formatCurrency(item?.earlyOut?.minute || 0),
            overtimeTotalHour: formatCurrency(item?.overtime?.totalHour || 0),
            overtimeTotalWorkDay: formatCurrency(item?.overtime?.totalWorkDay || 0),
            totalWorkDayShift : formatCurrency(item?.workDay?.shift || 0),
            totalWorkMission : formatCurrency(item?.workDay?.mission || 0),
            annualLeaveTotalUsed : formatCurrency(item?.annualLeave?.totalUsed || 0), //Phép đã dùng
            lateInFrequency : formatCurrency(item?.lateIn?.frequency || 0),
            lateWorkday : formatCurrency(item?.lateIn?.workday || 0),
            earlyOutWorkday : formatCurrency(item?.earlyOut?.workday || 0),
            noCheckInOutWorkday : formatCurrency(item?.noCheckInOut?.workday || 0),
            leaveWithoutReasonWorkDay : formatCurrency(item?.leaveWithoutReason?.workday || 0),
            compensatoryLeaveTotalUsed : formatCurrency(item?.compensatoryLeave?.totalUsed || 0),
            shiftMoreTotalWorkDay : formatCurrency(item?.shiftMore?.totalWorkDay || 0),
            shiftMoreTotalHour : formatCurrency(item?.shiftMore?.totalHour || 0),
            totalWorkHoliday : formatCurrency(item?.workDay?.holiday || 0),
            earlyFrequency : formatCurrency(item?.earlyOut?.frequency || 0),
            totalWorkHourReality : item?.totalWorkHourReality ? getTotalHourReality(item, item.totalWorkHourReality, (item?.totalHour || item?.totalWorkHour)) : '0',
            leaveNoReason : formatCurrency(item?.leaveNoReason || 0),
            latePenalty : formatCurrency(item?.lateIn?.penalty || 0),
            leaveWithoutReasonMoney : formatCurrency(item?.leaveWithoutReason?.penalty || 0),
            earlyOutPenalty : formatCurrency(item?.earlyOut?.penalty || 0),
            noCheckInOutMoney : formatCurrency(item?.noCheckInOut?.penalty || 0),


        }
    })

}

export function mapDetail(timeEngineDetails, item) {
    if (!timeEngineDetails) return;
    return timeEngineDetails?.map((value, index) => {

        if (value?.shifts?.length === 1) {
            return value?.shifts?.map((i) => {
                return <div className='cursor__pointer '>
                    <div style={{
                        fontSize: 14,
                        color: getClassRowNames(item, "#fff"),
                        fontWeight: 600
                    }}>  {i?.code}</div>
                    <div style={{
                        fontSize: 14,
                        color: getClassRowNames(item, "#fff"),
                        fontWeight: 600
                    }}>  {i?.timeStartString} - {i?.timeEndString}</div>

                </div>
            })
        } else if (value?.shifts?.length > 1) {
            return <>
                <div
                    style={{
                        fontSize: 14,
                        color: getClassRowNames(value, "#fff"),
                        fontWeight: 600
                    }}>
                    {value?.shifts[0]?.code} , + {value?.shifts?.length - 1}

                </div>

            </>
        }

        else
            return <></>

    })
}


export const colorBackground = {
    workday: "#12B76A",
    leaveNoReason: "#D0D5DD",
    casual: "#13C2C2",
    manual: "#007FFF",
    holiday: "#7A5AC7",
    editManual: "#FAAD14",
}

export const getClassRowNames = (record, value) => {

    if (record?.enabled)
        return "gray"
    else
        return value;
}
export   const getTotalHourReality = (item, totalWorkHourReality, totalHour) => {
    if (totalHour) {
        if (totalWorkHourReality > totalHour) {
            return <>{to2Floor(totalWorkHourReality)}&nbsp;<span
                style={{color: getClassRowNames(item, "#12B76A")}}>
                        (+{(convertHoursToHoursAndMinutes(totalWorkHourReality - totalHour))})</span></>
        } else if (totalWorkHourReality < totalHour) {
            return <>{to2Floor(totalWorkHourReality)}&nbsp;
                <span
                    style={{color: getClassRowNames(item, borderColorCell)}}>
                       (-{(convertHoursToHoursAndMinutes(totalHour - totalWorkHourReality))})</span></>
        }
        return to2Floor(totalWorkHourReality)

    } else {
        return to2Floor(totalWorkHourReality)
    }

}
